import mainCaller from './mainCaller';

const BASE = 'admin/api/v1/salary-settlements';

// 정산 목록 조회
export const getSettlementList = async (branchId, year, month, token) => {
  return await mainCaller(
    `${BASE}/list?branchId=${branchId}&year=${year}&month=${month}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};

// 정산 계산 (초안 생성)
export const calculateSettlement = async (data, token) => {
  return await mainCaller(BASE + '/calculate', 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 정산 상세 조회
export const getSettlementDetail = async (settlementId, branchId, token) => {
  return await mainCaller(`${BASE}/${settlementId}?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 수업 이력 조회
export const getSettlementLessons = async (settlementId, branchId, type, token) => {
  const query = type ? `&type=${type}` : '';
  return await mainCaller(`${BASE}/${settlementId}/lessons?branchId=${branchId}${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 수업이력 개별 건 수당 수정
export const updateSettlementLessonAllowance = async (settlementId, lessonId, branchId, data, token) => {
  return await mainCaller(`${BASE}/${settlementId}/lessons/${lessonId}?branchId=${branchId}`, 'PATCH', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 금액 조정 추가
export const addSettlementAdjustment = async (settlementId, branchId, data, token) => {
  return await mainCaller(`${BASE}/${settlementId}/adjustments?branchId=${branchId}`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

// 정산 확정
export const confirmSettlement = async (settlementId, branchId, token) => {
  return await mainCaller(`${BASE}/${settlementId}/confirm?branchId=${branchId}`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 정산 완료 취소 (CONFIRMED → DRAFT)
export const unconfirmSettlement = async (settlementId, branchId, token) => {
  return await mainCaller(`${BASE}/${settlementId}/unconfirm?branchId=${branchId}`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 정산 삭제 (DRAFT만)
export const deleteSettlement = async (settlementId, branchId, token) => {
  return await mainCaller(`${BASE}/${settlementId}?branchId=${branchId}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 정산 재계산 (DRAFT만). keepLessonIds에 담긴 수업은 재계산 후에도 수정된 금액을 유지한다.
export const recalculateSettlement = async (settlementId, branchId, keepLessonIds, token) => {
  return await mainCaller(
    `${BASE}/${settlementId}/recalculate?branchId=${branchId}`,
    'POST',
    { keepLessonIds },
    { Authorization: `Bearer ${token}` },
  );
};

// 근로시간 수동 입력
export const updateWorkHours = async (settlementId, branchId, hours, token) => {
  const params = new URLSearchParams({ branchId, ...hours });
  return await mainCaller(`${BASE}/${settlementId}/work-hours?${params}`, 'PUT', null, {
    Authorization: `Bearer ${token}`,
  });
};

// 최근 정산 이력
export const getRecentSettlements = async (employeeId, branchId, count, token) => {
  return await mainCaller(
    `${BASE}/${employeeId}/recent?branchId=${branchId}&count=${count}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
};
